// extracted by mini-css-extract-plugin
export default {"collapse":"Collapse_collapse__6A0-u","controlWrapper":"Collapse_controlWrapper__Zl88S"};